const baseSelector = (state) => state.rescheduleSbatGroup;

export const rescheduleModalStageSelector = (state) =>
  baseSelector(state).rescheduleModalStage;

export const rescheduleSbatGroupCommunicationsSelector = (state) =>
  baseSelector(state).communications;

export const selectedSbatGroupSelector = (state) =>
  baseSelector(state).selectedSbatGroup;

export const newDateOfTopicSelector = (state) =>
  baseSelector(state).newDateOfTopic;

export const rescheduleReasonSelector = (state) =>
  baseSelector(state).rescheduleReason;

export const rescheduleSbatGroupErrorsSelectors = (state) =>
  baseSelector(state).errors;

export const rescheduleSbatGroupValidateErrorMessageSelector = (state) =>
  baseSelector(state).rescheduleSbatGroupValidateErrorMessage;
